/**
 * FunqshopTicketAppHandler.js
 *
 * 機能概要：
 * 1. マイページの「チケット一覧」リンクを押すと、Funqshopチケットアプリのモーダルを開く
 *    （現在はPCボタンのみ。SPバーアイコンのクリック自動化は未使用）
 * 2. チケットアプリ内の「使用する」ボタンを「使用済み」に書き換え、無効化
 * 3. 「商品ページを見る」ボタンを無効化（クリック不可、グレー表示）
 * 4. DOMの変化を監視し、後から追加されたボタンにも自動で上記スタイルを適用
 * 5. 将来、許可ページリストはthema.liquidに書く
 *
 * 注意：
 * - SPバー用の自動クリック(waitAndClick)は現在使っていない
 * - 113 行目　        display: none !important;　→ display: block !important; でアイコン表示
 */
class FunqshopTicketAppHandler {
    constructor() {
        document.addEventListener("DOMContentLoaded", () => {
            // console.log("FunqshopTicketAppHandler initialized");

            this.openTicketApp = document.querySelector('#main_account__open-ticket-app');
            this.btn = document.querySelector('#amp-ticket-app');

            // console.log(this.openTicketApp);
            // console.log(this.btn);

            if (this.openTicketApp) {
                this.injectDynamicCSS();
            }

            this.attachOpenAppListener();
            this.updateButtons();
            this.observeDomChanges();
        });
    }

    waitAndClick(selector) {
        const interval = setInterval(() => {
            const target = document.querySelector(selector);
            if (target) {
                target.click();
                clearInterval(interval);
                // console.log('クリック成功:', selector);
            }
        }, 300);
    }

    attachOpenAppListener() {
        if (this.openTicketApp && this.btn) {
            this.openTicketApp.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.btn.querySelector('.ticket-app-coupon-ticket-app-pc')?.click();

                // this.waitAndClick('.coupon-ticket-app-sp .flex-between'); スマホのバーのアイコン対応。今はつかってない
            });
        }
    }

    updateButtons() {
        document.querySelectorAll('.ticket-app-item-modal-disabled .open-details-button').forEach(button => {
            if (button.textContent === '使用する') {
                button.textContent = '使用済み';
                button.style.backgroundColor = '#cccccc';
                button.style.color = '#666666';
            }
            // 「商品ページを見る」ボタン無効化　商品ページが非公開のため
            const parent = button.closest('.ticket-app-flex-item-button');
            const aTag = parent?.querySelector('a.ticket-app-a-href');

            if (aTag) {
                aTag.style.pointerEvents = 'none'; // クリック不可
                aTag.style.backgroundColor = '#cccccc';
                aTag.style.color = '#666666';
                aTag.style.cursor = 'default';
                aTag.setAttribute('aria-disabled', 'true');

                // 親要素のカーソルも上書き
                parent.style.cursor = 'default';
            }
        });
    }

    observeDomChanges() {
        const targetNode = document.body;
        const config = { childList: true, subtree: true };

        const callback = (mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length > 0) {
                    this.updateButtons();
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    // 動的CSS挿入処理
    injectDynamicCSS() {
        const style = document.createElement('style');
        style.innerHTML = `
      #amp-ticket-app {
        display: block !important;
      }
      #amp-ticket-app .ticket-app-coupon-ticket-app-sp {
        display: none !important;
      }
      #amp-ticket-app .ticket-app-coupon-ticket-app-pc{
        display: none !important;
      }
    `;
        document.head.appendChild(style);
        // console.log('動的CSSを挿入しました');
    }
}

new FunqshopTicketAppHandler();
